export default function authHeader() {
  const token = '';
  if (token) {
    return { Authorization: 'Bearer ' + token };
  } else {
    return { Authorization: '' };
  }
}
